export class PcbbHomepageAddButtons {
    public static readonly ADDTOBETSLIP: string = 'ADD TO BETSLIP';
    public static readonly ADDEDTOBETSLIP: string = 'ADDED TO BETSLIP';
    public static readonly ATTHERATE: string = '@';
    public static readonly FRACTION: string = 'frac';
}
export class Initiator {
    public static readonly FEATURED_MODULE: string = 'featuredModule';
}

export enum GA_CONSTANTS {
    BRAND = 'Pre created - Bet Builder',
    PBB_WIDGET = 'pre created bet builder widget',
    NOT_APPLICABLE = 'not applicable',
}
